module.exports = __webpack_public_path__ + "static/media/ucon5.c6362352.JPG";